import { render, staticRenderFns } from "./TermsWrapper.vue?vue&type=template&id=4b56276a&scoped=true"
import script from "./TermsWrapper.vue?vue&type=script&lang=js"
export * from "./TermsWrapper.vue?vue&type=script&lang=js"
import style0 from "./TermsWrapper.vue?vue&type=style&index=0&id=4b56276a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b56276a",
  null
  
)

export default component.exports